import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {Ttm} from '../../classes/ttm';
import {CodaltComponent} from '../codalt/codalt.component';
import {TtmService} from '../../services/ttm.service';
import {FormControl, Validators} from '@angular/forms';

@Component({
    selector: 'app-change-ttm-amount-dialog',
    templateUrl: './change-ttm-amount-dialog.component.html',
    styleUrl: './change-ttm-amount-dialog.component.scss'
})
export class ChangeTtmAmountDialogComponent extends CodaltComponent implements OnInit {

    maxAmount = 999999;
    minAmount = 1;
    fcAmount: FormControl<number>;

    constructor(public dialogRef: MatDialogRef<ChangeTtmAmountDialogComponent>,
                @Inject(MAT_DIALOG_DATA)
                public data: Ttm,
                private ttmService: TtmService) {
        super();
    }

    ngOnInit() {
        this.fcAmount = new FormControl(this.data.amount, [Validators.max(this.maxAmount), Validators.min(this.minAmount)]);
    }

    save() {
        this.subscriptions.add(this.ttmService.updateAmount(this.data.id, this.fcAmount.value).subscribe(ttm => {
            Object.assign(this.data, ttm.data);
            this.dialogRef.close(ttm);
        }));
    }
}
